import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SetField } from '../components/Table/fields/SetField';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { country } from './country';

export const user: SchemaWithClient<any> = {
  name: 'User',
  pluralName: 'User',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Full Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    email: {
      name: 'Email',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    phone: {
      name: 'Phone',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    alternative_phone: {
      name: 'Alternative Phone',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    ssn_number: {
      name: 'SSN Number',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    tax_number: {
      name: 'TAX Number',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    maiden_name: {
      name: 'Maiden Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    permanent_address: {
      name: 'Permanent Address',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    temporary_address: {
      name: 'Temporary Address',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    mothers_maiden_name: {
      name: "Mother's Maiden Name",
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    birthplace: {
      name: 'Birthplace',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    birthdate: {
      name: 'Birthdate',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'text',
    },

    bank_account_details: {
      name: 'Bank Account Details',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'text',
    },
    nationality: {
      name: 'Nationality',
      fieldRenderer: SelectField.tableAdapter(country),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(country),
      switchboard: true,
      url: country.client.getAllPath,
      tempSchema: country,
    },
    roles: {
      name: 'User Type',
      fieldRenderer: SetField.tableAdapter(enumItems.userType),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.userType),
      multiSwitchboard: true,
      url: enumItems.userType.client.getAllPath,
      tempSchema: enumItems.userType,
      editOnlyByAdmin: true
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/admin/users'),
};
